import { Lookup } from "./lookup";

export class Contact {
    id: string;
    firstName: string;
    lastName: Date;
    
}
